/**
 * Created by cd01 on 2017/12/12.
 */
require("./datePlugin.css");  //日期选择器样式
const datePluginTemplate = 'app/directives/datePlugin/datePlugin.html';

var datepickerapp = angular.module('datepickerapp', []);

datepickerapp.directive('datepicker', function () {
    return {
        restrict: "A",
        templateUrl: datePluginTemplate,
        scope: {},
        link: function (scope, element, attrs) {
            scope.realChoseDate = '';
            element[0].setAttribute('datepicker', scope.realChoseDate);
            //          console.log('父级',element[0].getAttribute('day'));
            //          var attrValue = element[0].getAttribute('day');
            var _date = new Date();
            scope.year = _date.getFullYear();
            scope.month = _date.getMonth() + 1;
            scope.date = _date.getDate(); //日期号数
            scope.realChoseDate = scope.year + '-' + scope.month + '-' + scope.date;
            element[0].setAttribute('datepicker', scope.realChoseDate);
            // $scope.day = _date.getDay();
            // console.log('星期'+ $scope.day);
            getDaysNumber(scope.year, scope.month);

            scope.yearUp = function () {
                scope.year++;
                getDaysNumber(scope.year, scope.month);
                lastMonLowlight();
                choseDateHeighlight(scope.date);
            };
            scope.yearDown = function () {
                scope.year--;
                getDaysNumber(scope.year, scope.month);
                lastMonLowlight();
                choseDateHeighlight(scope.date);
            };
            scope.monthUp = function () {
                if (scope.month == 12) {
                    scope.year++;
                    scope.month = 1;
                    getDaysNumber(scope.year, scope.month);
                } else {
                    scope.month++;
                    getDaysNumber(scope.year, scope.month);
                }
                lastMonLowlight();
                choseDateHeighlight(scope.date);
            };
            scope.monthDown = function () {
                if (scope.month == 1) {
                    scope.year--;
                    scope.month = 12;
                    getDaysNumber(scope.year, scope.month);
                } else {
                    scope.month--;
                    getDaysNumber(scope.year, scope.month);
                }
                lastMonLowlight();
                choseDateHeighlight(scope.date);
            };

            //点击某日，选取该天日期
            scope.choseDate = function (e, $index) {
                console.log('点击项', e);
                console.log('点击下标', $index);
                scope.date = e;
                if (e > 15 && $index < 7) {
                    //点击的是上月份的日期，日历跳到上月份去。
                    if (scope.month == 1) {
                        scope.year--;
                        scope.month = 12;
                    } else {
                        scope.month--;
                    }
                    getDaysNumber(scope.year, scope.month);

                    scope.realChoseDate = scope.year + '-' + scope.month + '-' + e;
                    element[0].setAttribute('datepicker', scope.realChoseDate);
                    //				    console.log('选择日期', scope.realDate);
                    console.log('选择日期', scope.realChoseDate);
                    scope.calendarOpen = false;
                    scope.clickMasking()   //添加的遮罩层
                    //
                    choseDateHeighlight(e);
                    lastMonLowlight();
                    return false;
                }
                // console.log('选择日期',$scope.year + '-' + $scope.month + '-' + e);
                scope.realChoseDate = scope.year + '-' + scope.month + '-' + e;
                element[0].setAttribute('datepicker', scope.realChoseDate);
                //				console.log('选择日期', scope.realDate);
                console.log('选择日期', scope.realChoseDate);
                choseDateHeighlight(scope.date);
                lastMonLowlight();
                scope.calendarOpen = false;
                scope.clickMasking()   //添加的遮罩层

            };
            //获取该月份的天数
            function getDaysNumber(year, month) {
                var arr1 = [1, 3, 5, 7, 8, 10, 12];
                var arr2 = [4, 6, 9, 11];
                var arr3 = [2];
                var daysNumber = null;
                if (arr1.indexOf(month) != -1) {
                    daysNumber = 31;
                } else if (arr2.indexOf(month) != -1) {
                    daysNumber = 30;
                } else if (arr3.indexOf(month) != -1) {
                    if ((year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)) {
                        //闰年
                        daysNumber = 29;
                    } else {
                        daysNumber = 28;
                    }
                }
                ;
                //把该月份的日期的号数弄成一个数组集。
                scope.daysNumber = [];
                for (var i = 1; i <= daysNumber; i++) {
                    scope.daysNumber.push(i);
                }
                ;
                //检测这个月的一号是星期几 (一月份的不准确)
                var day = new Date(year, month - 1, 1).getDay();
                if (day == 0) {
                    day = 7; //因为星期日的day是‘0’；
                }
                console.log('一号是星期', day);
                //填充第一行
                // 获取上个月的天数
                var lastMonthDays = getLastMonthDays(scope.year, scope.month - 1);
                console.log('上一个月的天数', lastMonthDays);
                for (var i = 1; i < day; i++) {
                    scope.daysNumber.unshift(lastMonthDays--);
                }
                console.log(scope.daysNumber);

                // choseDateHeighlight($scope.date);

            };
            //选取日期高亮
            function choseDateHeighlight(date) {
                console.log('高亮的日期', date);
                if (date < 15) {
                    for (var i = 0; i < scope.daysNumber.length; i++) {
                        if (scope.daysNumber[i] == date) {
                            //var dateDiv = document.getElementsByClassName('date')[0];
                            //这里英爱获取的是该 element 下的dateDiv:
                            console.log('高亮函数输出element', element);
                            var dateDiv = element[0].getElementsByClassName('date')[0]

                            console.log(dateDiv);
                            var lis = dateDiv.getElementsByTagName('li');
                            console.log(lis.item(i));
                            for (var j = 0; j < lis.length; j++) {
                                var classVal = lis.item(j).getAttribute("class");
                                classVal = " " + classVal + " ";
                                classVal = classVal.replace(" active ", " ");
                                lis.item(j).setAttribute("class", classVal);
                            }
                            // lis.item(i).setAttribute("className","active");
                            lis.item(i).className = "active";
                            break;
                        }
                    }
                } else {
                    for (var i = 15; i < scope.daysNumber.length; i++) {

                        if (scope.daysNumber[i] == date) {
                            //							var dateDiv = document.getElementsByClassName('date')[0];
                            //这里英爱获取的是该 element 下的dateDiv:
                            console.log('高亮函数输出element', element);
                            var dateDiv = element[0].getElementsByClassName('date')[0]

                            console.log(dateDiv);
                            var lis = dateDiv.getElementsByTagName('li');
                            console.log('lis集合：', lis);
                            console.log('第几个i', i);
                            console.log(lis.item(i));
                            for (var j = 0; j < lis.length; j++) {
                                var classVal = lis.item(j).getAttribute("class");
                                classVal = " " + classVal + " ";
                                classVal = classVal.replace(" active ", " ");
                                lis.item(j).setAttribute("class", classVal);
                            }
                            // lis.item(i).setAttribute("className","active");
                            lis.item(i).className = "active";
                            break;
                        }
                    }
                }

            }

            //上月的日期低亮
            function lastMonLowlight() {

                //				var dateDiv = document.getElementsByClassName('date')[0];
                var dateDiv = element[0].getElementsByClassName('date')[0];
                var lis = dateDiv.getElementsByTagName('li');
                for (var i = 0; i < 7; i++) {
                    var classVal = lis.item(i).getAttribute("class");
                    classVal = " " + classVal + " ";
                    classVal = classVal.replace(" lowlight ", " ");
                    lis.item(i).setAttribute("class", classVal);
                }
                for (var i = 0; i < scope.daysNumber.length; i++) {
                    if (scope.daysNumber[i] == 1) {
                        console.log('低亮日期最大值', scope.daysNumber[i - 1]);
                        // lis.item(i).className = "lowlight";
                        for (var j = 0; j < i; j++) {
                            lis.item(j).className = "lowlight";
                        }
                        break;
                    }
                }
            }

            function checkInArray(e, arry) {
                //判断元素是否在数组里。
                // http://www.jb51.net/article/81762.htm

                if (!Array.indexOf) {
                    Array.prototype.indexOf = function (obj) {
                        for (var i = 0; i < this.length; i++) {
                            if (this[i] == obj) {
                                return i;
                            }
                        }
                        return -1;
                    }
                }
                ;

            }

            //点击日期开关
            scope.calendar = function ($event) {
                //				lastMonLowlight();
                //				choseDateHeighlight(scope.date);
                if (!scope.calendarOpen) {
                    scope.calendarOpen = true;
                    console.log($event.target.parentNode);
                    var pos = $event.target.parentNode.getBoundingClientRect();
                    //下面输出的都是相对于浏览器的最左上角位置（0，0）.
                    // console.log('top值（元素顶部边界）', pos.top);
                    // console.log('left值（元素左边边界）', pos.left);
                    // console.log('bottom值（元素底部边界）', pos.bottom);
                    // console.log('right值（元素右边边界）', pos.right);
                    // console.log('width值（元素宽度）', pos.width);
                    // console.log('height值（元素高度）', pos.height);

                    function getNextElement(node) {
                        console.log('节点类型:', node.nodeType, node);
                        if (node.nodeType == 1) {
                            return node;
                        }
                        if (node.nextElementSibling || node.nextSibling) {
                            return getNextElement(node.nextElementSibling || node.nextSibling);
                        }
                        return null;
                    }

                    function getNextNode(node) {

                    }

                    var datePluginBox = getNextElement($event.target.parentNode.nextElementSibling || $event.target.parentNode.nextSibling);
                    var _screenHeight = document.documentElement.clientHeight;
                    var _screeWidth = document.documentElement.clientWidth;
                    var _toBottomHeight = _screenHeight - pos.bottom
                    var _toRightWidth = _screeWidth - pos.left
                    var _datePluginBoxHeight = datePluginBox.getBoundingClientRect().height;
                    // console.log('浏览器可视高度', _screenHeight);
                    // console.log('日期框元素距离浏览器底部的距离', _toBottomHeight);
                    // console.log('日期框元素左边界距离浏览器最右边的距离', _toRightWidth);
                    if (_toBottomHeight > 320) {
                        datePluginBox.style.position = "fixed";
                        datePluginBox.style.top = (pos.top * 1 + 30) + 'px';

                        datePluginBox.style.zIndex = 10000;
                    } else {
                        datePluginBox.style.position = "fixed";
                        datePluginBox.style.top = (pos.top * 1 - 290) + 'px';
                        datePluginBox.style.zIndex = 10000;
                    }
                    ;
                    if (_toRightWidth > 310) {
                        datePluginBox.style.left = pos.left + 'px';
                    } else {
                        datePluginBox.style.right = 15 + 'px';
                    }


                    //获取遮罩层元素
                    var maskingDiv = getNextElement(datePluginBox.nextElementSibling || datePluginBox.nextSibling);
                    console.log('遮罩层元素',maskingDiv);
                    maskingDiv.style.display = "block";
                    maskingDiv.style.position = "fixed";
                    maskingDiv.style.top = 0;
                    maskingDiv.style.left = 0;
                    maskingDiv.style.bottom = 0;
                    maskingDiv.style.right = 0;
                    maskingDiv.style.zIndex = 999;

                } else {
                    scope.calendarOpen = false;
                }

            }

            //获取上个月的天数
            function getLastMonthDays(year, month) {
                var d = new Date(year, month, 0);
                return d.getDate();
            }

            //点击确认按钮
            scope.sure = function () {
                scope.realChoseDate = scope.year + '-' + scope.month + '-' + scope.date;
                element[0].setAttribute('datepicker', scope.realChoseDate);
                scope.calendarOpen = false;
                scope.clickMasking()   //添加的遮罩层
            }
            //点击今天按钮
            scope.today = function () {
                var _date = new Date();
                scope.year = _date.getFullYear();
                scope.month = _date.getMonth() + 1;
                scope.date = _date.getDate(); //日期号数
                getDaysNumber(scope.year, scope.month);
                lastMonLowlight();
                choseDateHeighlight(scope.date);
                scope.realChoseDate = scope.year + '-' + scope.month + '-' + scope.date;
                console.log('点击今天按钮时realChoseDate的值：', scope.realChoseDate);
                element[0].setAttribute('datepicker', scope.realChoseDate);
                scope.calendarOpen = false;
                scope.clickMasking()   //添加的遮罩层
            };
            //点击遮罩层空白处。
            scope.clickMasking = function () {
                scope.calendarOpen = false;
//				console.log('遮罩层函数输出的element',element[0]);
//				console.log('查找遮罩层',element[0].getElementsByTagName('div')[0].getElementsByClassName('whiteBack')[0]);
                scope.realChoseDate = scope.year + '-' + scope.month + '-' + scope.date;
                console.log('点击遮罩层空白处时realChoseDate的值：', scope.realChoseDate);
                element[0].setAttribute('datepicker', scope.realChoseDate);
                var maskingDiv = element[0].getElementsByTagName('div')[0].getElementsByClassName('whiteBack')[0];
                maskingDiv.style.display = 'none';

            };

            //日期渲染完成后执行的操作
            scope.renderFinish = function () {
                console.log('进来日期渲染完成后执行的函数');
                lastMonLowlight();
                choseDateHeighlight(scope.date);
                //控制日历位置
                //				var datePluginDiv = document.getElementsByClassName('datePlugin')[0];
                //				datePluginDiv.style.cssText = "zIndex:1000; position: fixed; top:10px; right:10px;"
            }
        }
    }
});
datepickerapp.directive('repeatFinish', function () {
    return {
        link: function (scope, element, attr) {
            if (scope.$last == true) {
                scope.$eval(attr.repeatFinish);
            }
        }
    }
});
